import { RollbackOutlined } from '@ant-design/icons'
import { Button, DatePicker, Form, Input, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import TableSample from './TableSample'
import dayjs from 'dayjs'
import InputModal from '../../../../Components/InputModal'
import { GetAllSales, GetCustomers, GetOrders } from '../../../../API/GetData'
import HeaderTitle from '../../../../Components/HeaderTitle'
import { AuthData } from '../../../../Components/Global'
import { PostOrder } from '../../../../API/PostData'

const FormOrder = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const Auth = AuthData();

    const [form] = Form.useForm();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);

    const [add, setAdd] = useState(false);

    const [orderCode, setOrderCode] = useState("");

    const [dataOrder, setDataOrder] = useState(null);

    const [dataCustomer, setDataCustomer] = useState([]);
    const [selectCustomer, setSelectCustomer] = useState("");
    const [openCustomer, setOpenCustomer] = useState(null);


    const [dataSales, setDataSales] = useState([]);
    const [selectSales, setSelectSales] = useState("");
    const [openSales, setOpenSales] = useState(null);

    useEffect(() => {
        const fetchDataLocalStorage = () => {
            const storedData = localStorage.getItem('DataOrder');
            if (storedData) {
                const Data = JSON.parse(storedData);
                setDataOrder(Data);

                const payload = {
                    ...Data,
                    OrderDate: dayjs(Data.OrderDate)
                }
                form.setFieldsValue(payload);
            }
        }

        fetchDataLocalStorage();
        setOpenCustomer(true);
        setOpenSales(true);
    }, [form]);

    // CUSTOMER
    useEffect(() => {
        const fetchCustomer = async () => {
            try {
                setIsLoading(true);
                const res = await GetCustomers();
                setDataCustomer(res);

                if (dataOrder) {
                    const filterRes = res.find((item) => item.CustomerId === dataOrder.CustomerId);
                    setSelectCustomer(filterRes);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false);
                setOpenCustomer(false);
            }
        };

        if (openCustomer) {
            fetchCustomer();
        }
    }, [dataOrder, openCustomer]);


    // SALES
    useEffect(() => {
        const fetchSales = async () => {
            try {
                setIsLoading(true);
                const res = await GetAllSales();
                setDataSales(res);

                if (dataOrder && dataOrder.SalesCode && dataOrder.SalesName) {
                    const filterRes = res.find((item) => item.SalesCode === dataOrder.SalesCode);
                    setSelectSales(filterRes);
                }
            } catch (error) {
                console.log(error);
            }
            setIsLoading(false);
        }
        if (openSales) {
            fetchSales();
            setOpenSales(false);
        }
    }, [dataOrder, openSales]);


    useEffect(() => {
        if (form && (selectCustomer || selectSales)) {
            form.setFieldsValue({
                CustomerName: selectCustomer.CustomerName,
                SalesName: selectSales.SalesName,
            })
        }
    }, [form, selectCustomer, selectSales]);

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const res = await GetOrders();
                if (res.length > 0) {
                    const filteredData = res.filter(code => code.OrderCode.startsWith("OC"));
                    if (filteredData.length > 0) {
                        const lastCode = filteredData[filteredData.length - 1].OrderCode;
                        const nextNumber = parseInt(lastCode.substr(2)) + 1;
                        const nextCode = `OC${nextNumber.toString().padStart(4, "0")}`
                        setOrderCode(nextCode);
                    } else {
                        setOrderCode("OC0001");
                    }
                } else {
                    setOrderCode("OC0001");
                }
            } catch (error) {
                console.log(error);
            }
        }

        fetchOrders();

    }, []);

    useEffect(() => {
        if (form && orderCode && !dataOrder) {
            form.setFieldsValue({
                OrderCode: orderCode,
                OrderDate: dayjs(),
            });
        }
    }, [dataOrder, form, orderCode]);


    const handleSubmit = async (values) => {

        const DataSample = JSON.parse(localStorage.getItem('DataSample'));

        try {
            setIsLoading(true);
            const payload = {
                ...values,
                AccountId: Auth.AccountId,
                CustomerId: selectCustomer.CustomerId,
                SalesCode: selectSales.SalesCode,
                OrderDate: dayjs(values.OrderDate).format('YYYY-MM-DD'),
                ReviewedBy: Auth.CustomerId,
                Sample: DataSample
            };

            if (!add) {
                // console.log('Submit', payload);
                const response = await PostOrder(payload);
                // console.log("Submit Data", response);
                if (response.status === 201 || response.status === 200) {
                    message.success(response.data.message);
                    navigate("/dashboard/menuorder/order");
                    localStorage.removeItem("DataOrder");
                    localStorage.removeItem("DataSample");
                }
            } else {
                localStorage.setItem('DataOrder', JSON.stringify(payload));
                navigate('/dashboard/menuorder/order/sample/form');
            }

        } catch (error) {
            message.error(error.response.data.error);
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleReset = () => {
        form.resetFields();
    }

    const handleAdd = async () => {
        try {
            await form.validateFields();
            setAdd(true);
            form.submit();
        } catch (error) {
            message.error("Complete the Order data!");
            window.scrollTo(0, 0);
        }
    };

    const handleBack = () => {
        navigate("/dashboard/menuorder/order");
        localStorage.removeItem("DataOrder");
        localStorage.removeItem("DataSample");
    }


    return (
        <>
            {/* <TestUpload /> */}
            <div className="flex justify-between items-center">
                <HeaderTitle title="FORM ORDER" subtitle="Create a Order Data" />
                <Button icon={<RollbackOutlined />} onClick={handleBack}>Back</Button>
            </div>

            <div className="bg-white p-4 rounded-md mt-4">
                <Form
                    name="formOrder"
                    layout="vertical"
                    onFinish={handleSubmit}
                    autoComplete="off"
                    form={form}
                >

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">

                        <Form.Item
                            label="Order Code"
                            name="OrderCode"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Order Code!',
                                },
                            ]}
                        >
                            <Input placeholder="Order Code" disabled />
                        </Form.Item>

                        <Form.Item
                            label="Order Quotation"
                            name="OrderQuotation"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Order Quotation!',
                                },
                            ]}
                        >
                            <Input placeholder="Order Quotation" />
                        </Form.Item>

                        <Form.Item
                            label="Order Date"
                            name="OrderDate"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Order Date!',
                                },
                            ]}
                        >
                            <DatePicker placeholder="Order Date" className="w-full" />
                        </Form.Item>

                        <InputModal
                            title="CUSTOMER"
                            label="Customer"
                            name="CustomerName"
                            dataSource={dataCustomer}
                            loading={isLoading}
                            columns={columnsCustomer}
                            onData={(values) => setSelectCustomer(values)}
                            onOpenModal={(values) => setOpenCustomer(values)}
                        />

                        <InputModal
                            title="SALES"
                            label="Sales"
                            name="SalesName"
                            dataSource={dataSales}
                            loading={isLoading}
                            columns={columnsSales}
                            onData={(values) => setSelectSales(values)}
                            onOpenModal={(values) => setOpenSales(values)}
                        />

                        <Form.Item
                            label="Department"
                            name="Department"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Department!',
                                },
                            ]}
                        >
                            <Input placeholder="Department" />
                        </Form.Item>

                        <Form.Item
                            label="Max TAT"
                            name="MaxTAT"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your MaxTAT!',
                                },
                            ]}
                        >
                            <Input placeholder="MaxTAT" />
                        </Form.Item>

                        <Form.Item
                            label="Decription"
                            name="Decription"
                        >
                            <Input.TextArea placeholder="Decription" rows={4} />
                        </Form.Item>

                    </div>

                    <TableSample onData={handleAdd} />

                    <div className="flex flex-row justify-end gap-2">
                        <Button type="primary" htmlType="submit" loading={isLoading}>Submit</Button>
                        <Button htmlType="button" onClick={handleReset}>Reset</Button>
                    </div>

                </Form>
            </div>
            
        </>
    )
}

export default FormOrder;


const columnsCustomer = [
    {
        dataIndex: "CustomerName",
        title: "Customer Name",
        key: "CustomerName",
    },
    {
        dataIndex: "ContactPerson",
        title: "Contact Person",
        key: "ContactPerson",
    },
    {
        dataIndex: "Address",
        title: "Address",
        key: "Address",
    },
    {
        dataIndex: "EmailContact",
        title: "Email Contact",
        key: "EmailContact",
    },
    {
        dataIndex: "Phone",
        title: "Phone",
        key: "Phone",
    },
    {
        dataIndex: "MobilePhone",
        title: "Mobile Phone",
        key: "MobilePhone",
    },
    {
        dataIndex: "Fax",
        title: "Fax",
        key: "Fax",
    },
];

const columnsSales = [
    {
        dataIndex: "key",
        title: "#",
        key: "key",
    },
    {
        dataIndex: "SalesName",
        title: "Sales Name",
        key: "SalesName",
    },
    {
        dataIndex: "SalesNumber",
        title: "Sales Number",
        key: "SalesNumber",
    }
]